import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=4b453b59&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=4b453b59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b453b59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b453b59')) {
      api.createRecord('4b453b59', component.options)
    } else {
      api.reload('4b453b59', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=4b453b59&scoped=true&", function () {
      api.rerender('4b453b59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Tfvs1fRTZdVR/JS/comp/DateRangeExt.vue"
export default component.exports